import { createApp } from 'vue'
import App from './App.vue'
import router from './router'
import './assets/bootstrap.scss'
import './assets/global.scss'

createApp(App).use(router).mount('#movie-app')
